import { DatePicker, Label } from "@fluentui/react";
import { DayPickerStrings } from "../../utils/DayPickerStrings";

interface DateFieldProps {
  label: string;
  required?: boolean;
  value: Date | undefined;
  onChange: (date: Date | null | undefined) => void;
  errorMessage?: string;
  description?: string;
}

export default function DateField({ label, required, value, onChange, errorMessage, description }: DateFieldProps) {
  const formatDate = (date?: Date) => {
    if (!date) return "";
    let day = date.getDate().toString();
    let month = (date.getMonth() + 1).toString();
    const year = date.getFullYear();
    if (Number(day) < 10) day = `0${day}`;
    if (Number(month) < 10) month = `0${month}`;
    return `${day}/${month}/${year}`;
  };

  return (
    <>
      <DatePicker
        label={label}
        isRequired={required}
        value={value}
        onSelectDate={onChange}
        formatDate={formatDate}
        strings={DayPickerStrings}
        placeholder="Seleccione una fecha"
        showWeekNumbers={false}
        showMonthPickerAsOverlay={true}
        ariaLabel={label}
      />
      {errorMessage && (
        <span role="alert" style={{ color: "#a4262c", fontSize: 12 }}>
          {errorMessage}
        </span>
      )}
      {description && (
        <Label disabled style={{ fontSize: "12px" }}>
          {description}
        </Label>
      )}
    </>
  );
}
